import { useEffect, useState, memo } from 'react'
import { useI18n } from '../i18n/I18nContext'

interface ToastProps {
  message: string
  type?: 'success' | 'error' | 'info'
  duration?: number
  onClose: () => void
}

export const Toast = memo(function Toast({ message, type = 'info', duration = 3000, onClose }: ToastProps) {
  const { t } = useI18n()
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false)
      setTimeout(onClose, 300)
    }, duration)

    return () => clearTimeout(timer)
  }, [duration, onClose])

  const typeStyles = {
    success: {
      bg: 'rgba(16, 185, 129, 0.1)',
      border: '#10b981',
      icon: '✅'
    },
    error: {
      bg: 'rgba(245, 101, 101, 0.1)',
      border: '#f56565',
      icon: '❌'
    },
    info: {
      bg: 'rgba(59, 130, 246, 0.1)',
      border: '#3b82f6',
      icon: 'ℹ️'
    }
  }

  const style = typeStyles[type]

  return (
    <div
      className={`toast ${isVisible ? 'toast-visible' : 'toast-hidden'}`}
      style={{
        background: style.bg,
        borderColor: style.border
      }}
    >
      <span className="toast-icon">{style.icon}</span>
      <span className="toast-message">{message}</span>
      <button
        type="button"
        className="toast-close"
        aria-label={t('buttons.dismiss')}
        onClick={() => {
          setIsVisible(false)
          setTimeout(onClose, 300)
        }}
      >
        ✕
      </button>
    </div>
  )
})
